import { render, staticRenderFns } from "./CopyrightIncomeCopy.vue?vue&type=template&id=600f5e30&scoped=true&"
import script from "./CopyrightIncomeCopy.vue?vue&type=script&lang=js&"
export * from "./CopyrightIncomeCopy.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightIncomeCopy.vue?vue&type=style&index=0&id=600f5e30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600f5e30",
  null
  
)

export default component.exports